import React, { Component } from 'react';
import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';
import { store } from "../../../testStore";

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../../redux/ducks'
import { actions as notificationActions } from '../../../redux/ducks/notification'

/* Routes */
import { domainIsTenant as dit, S } from '../../../routes/routes'

/* Object Json */
import { isEmpty } from 'iotera-base/object';
import { parseAny, safeGet, safeGetWithType, stringify } from 'iotera-base/json';
import { IoteraForm } from '../../../lib/components/form';
import { SubViewHeader } from '../../../lib/components/subHeader';

import './style.scss'
import DropdownTreeSelect from 'react-dropdown-tree-select';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { setRoleAccess, setEditRoleDirect } from '../../../testActions';
import { InlineTooltip } from '../../../lib/components/tooltips';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../../lib/components/callbackGlobal';

const WKEY = "ROLE_EDIT";
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

function schema() {
  return {
  }
};

function uiSchema() {
  return {
  }
};

class RoleEditAccess extends Component {
  constructor(props) {
    super(props)
    const roleId = safeGet(this, ['props', 'match', 'params', 'id']);
    this.state = {
      value: [],
      formData: {},
      values: '',
      isSubmit: false,
      roleId,
      descendant: false,
      selectedNodes: [],
      navs: [],
      loading: true
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const { roleId } = _state;
    if (isEmpty(roleId)) {
      return {}
    }
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        wparam: { ...domainIsTenant, path: "/service/web/application/account/role/get/id/" + roleId },
        wcallback: {
          started: function (id) {
            // TODO Loading
          },
          finished: function (id, result) {
            let navs = safeGetWithType(result, ['body', 'navs'], [])
            let navsObj = safeGetWithType(result, ['body', 'navs_root_obj'], {})
            // TODO Loading
            _this.setState({
              navs,
              navsObj,
              loading: false
            })
          }
        }
      }
    );
  }

  componentWillUnmount() {
    const _this = this;
    const _state = _this.state
    const _props = _this.props
    const { roleId } = _state;
    if (isEmpty(roleId)) {
      return {}
    }
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  handleSubmit(event) {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const id = _props.roleId;
    let selectedNodes = safeGetWithType(_this, ['access', 'state', 'tags'], []);
    let descendant = safeGetWithType(_state, ['descendant'], false);
    let navsObj = safeGetWithType(_state, ['navsObj'], {});
    // if (selectedNodes.length === 0) {
    //   _props.showSingleNotification({ message: 'Harus memiliki setidaknya satu akses dashboard', position: 'tr', level: 'error' });
    //   return;
    // }
    let role =
    {
      navs: selectedNodes,
      navsObj,
      descendant
    }
    let action = setRoleAccess(role);
    store.dispatch(action)
    let directAction = setEditRoleDirect(false)
    store.dispatch(directAction)
    _props.history.push('..' + S + '_role_edit_sort_' + S + id);
  }

  onChange = (currentNode, selectedNodes) => {
  };

  handleDesc = () => event => {
    const _this = this;
    const _state = _this.state
    let formData = safeGetWithType(_this, ['form', 'state', 'formData'], {});
    _this.setState({ descendant: !_state.descendant, formData, selectedNodes: [] })
  }

  goTo(link) {
    this.props.history.push(link)
  }

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const { loading } = _state;
    let dataToShow = {};
    if (isEmpty(_state.formData)) {
      dataToShow = {}
    } else {
      dataToShow = _state.formData;
    }
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    const role = safeGetWithType(_props, ['role'], {});
    dataToShow.name = safeGetWithType(role, ['name'], '');
    dataToShow.description = safeGetWithType(role, ['description'], '');
    dataToShow.permissions = stringify(safeGetWithType(role, ['permissions'], '{}'));
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title='Edit Role' subTitle='Formulir Edit Role' />
          <div className="io-container mt-12">
            <IoteraForm
              schema={schema()}
              uiSchema={uiSchema()}
              onSubmit={_this.handleSubmit}
              formData={dataToShow}
            >
              <label style={{ marginBottom: 7 }}>
                <b>Akses Dashboard*</b>
                <InlineTooltip id={'test'} text={'Dashboard yang dipilih akan dapat diakses oleh role ini'} />
              </label>
              <DropdownTreeSelect
                ref={(access) => { _this.access = access; }}
                data={_state.navs}
                placeholderText="Cari..."
                keepTreeOnSearch={true}
                className="dropdown-tree-iotera"
                hierarchical={!_state.descendant}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={_state.descendant}
                    onChange={_this.handleDesc()}
                    color="primary"
                    style={{ padding: 0, margin: '0px 12px' }}
                  />
                }
                label="Include All Children"
              />
              <div className="button-right" style={{ marginTop: 10 }}>
                <button className="button-iotera-white" type="button" style={{ minWidth: '0%' }}
                  onClick={(e) => _this.goTo('..' + S + '_role_list_')} >Batal</button>
                <button className="button-iotera-primary" type="submit"
                  style={{ marginLeft: 10, minWidth: '0%' }}>Berikutnya</button>
              </div>
            </IoteraForm>
          </div>
        </div>
      </Loader>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    role: wSelector.getSoleInitMappedRPayload(state),
    roleId: wSelector.getSoleInitMappedRPayload(state, 'id')
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...wBoundActions(dispatch),
  ...bindActionCreators(notificationActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(RoleEditAccess);
